module.exports = __webpack_public_path__ + "static/media/junior_tour_step2.dfa7eb3a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gJunior/junior_tour_step2.svg
// module id = 328
// module chunks = 21